module.exports = {
      id: "circle-bordered-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#circle-bordered",
      toString: function () {
        return this.url;
      }
    }